/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */

const $ = require('jquery')
const _ = require('underscore')

const trans = require('trans')
const router = require('router')
const Captcha = require('UI/Captcha')
const { gaHelper } = require('../app/containers/AnalyticsGoogleTag/gaHelper')

const CONST = {
  SUCCESS_CONTENT: 'html',
  SUCCESS_DATA: 'data',
  SUCCESS_MESSAGE: 'message',
  SUCCESS_FORMSUBMIT: 'form_submit',
  SUCCESS_REDIRECT: 'redirect',
  ERROR_MESSAGE: 'error_message',
  ERROR_FORM: 'form_error',
  ERROR_LOGINREQUIRED: 'login_required',
}

function ajax(url, options) {
  if (!url) {
    return undefined
  }
  if (!options) {
    options = {}
  }

  if (_.isArray(url)) {
    url = router.path(url[0], url[1])
  }

  const o = {
    dataType: options.dataType || 'html',
    type: options.type || 'get',
    data: options.data || undefined,
    done: options.done || undefined,
    fail: options.fail || undefined,
    abort: options.abort || undefined,
    always: options.always || undefined,
    msgContainer: options.msgContainer || undefined,
    captchaBox: options.captchaBox || undefined,
    form: options.form || undefined,
    addMsg: options.addMsg || undefined,
  }

  const jqXHR = $.ajax({
    url,
    type: o.type,
    data: o.data,
    dataType: o.dataType,
    xhrFields: {
      withCredentials: !!window.DEBUG,
    },
  })
    .done((data, textStatus, resultJqXHR) => {
      if (o.dataType === 'json') {
        data = new ResponseModel(data)
      }
      done(data, textStatus, resultJqXHR, url, o)
    })
    .fail((resultJqXHR, textStatus, errorThrown) => {
      if (textStatus === 'abort') {
        abort(resultJqXHR, textStatus, errorThrown, url, o)
      } else {
        fail(undefined, resultJqXHR, textStatus, errorThrown, url, o)
      }
    })

  jqXHR._url = url
  jqXHR._options = o

  return jqXHR
}

function done(data, textStatus, jqXHR, url, options) {
  // Test type
  if (options.dataType === 'html') {
    if (data && _.isString(data) && data !== '') {
      callback(options.done, [data])
    } else {
      $.infobox(trans('unknown_error'), 'error')
      callback(options.done, [undefined])
    }
  } else if (options.dataType === 'json') {
    if (data.success === true) {
      // success with content
      if (data.type === CONST.SUCCESS_DATA && !_.isObject(data.data) && !_.isString(data.data)) {
        // success with data
        fail(data, jqXHR, textStatus, undefined, url, options)
        return
      } else if (data.type === CONST.SUCCESS_MESSAGE) {
        // success with msg
        printMsg(data.data, options, 'success')
      } else if (data.type === CONST.SUCCESS_REDIRECT) {
        // succes with redirecr
        let redirectUrl = data.data

        if (!redirectUrl || !_.isString(redirectUrl) || redirectUrl === '/' || redirectUrl === '') {
          redirectUrl = router.path('multilotto_site_homepage')
        }
        // alert('Redirecting to -> ' + url);
        router.redirect(redirectUrl)
      } else if (data.type === CONST.SUCCESS_FORMSUBMIT) {
        // succes with form to submit
        $(data.data).appendTo('#js').submit()
      }
      callback(options.done, [data])
    } else {
      fail(data, jqXHR, textStatus, undefined, url, options)
      return
    }
  } else if (options.dataType === 'xml') {
    callback(options.done, [data])
  }

  always(data, jqXHR, textStatus, undefined, url, options)
}

function fail(data, jqXHR, textStatus, errorThrown, url, options) {
  // console.log({jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown});

  if (!data) {
    data = jqXHR.responseText
    if (options.dataType === 'json' && jqXHR.responseText) {
      try {
        data = new ResponseModel(JSON.parse(jqXHR.responseText))
      } catch (exception) {
        data = new ResponseModel({
          data: trans('unknown_error'),
          type: CONST.ERROR_MESSAGE,
        })
      }
    }
  }

  let errMsg = errorThrown
  if (!errMsg) {
    if (_.isObject(data.data) && data.data.message) {
      errMsg = data.data.message
    } else if (_.isString(data.data)) {
      errMsg = data.data
    }
  }

  gaHelper.addError(4100100, errMsg)

  if (options.dataType === 'json') {
    if (data && data.success === false) {
      if ((options.form && options.form.length) || options.captchaBx) {
        const cb = options.captchaBox || options.form
        let captcha = cb.data('captcha')

        if (captcha) {
          // CAPTCHA WAS INITED
          captcha.reload()
        } else if (cb.find('i.captcha-reload').length) {
          // CAPTCHA IS IN FORM BUT NOT INITTED YET
          captcha = new Captcha(cb)
          captcha.reload()
        } else if (data.captcha) {
          // IF CAPTCHA INIT IS NEEDED
          captcha = new Captcha(cb)

          if (options.captchaBox && options.captchaBox.length) {
            cb.append(captcha.el)
          } else if (options.msgContainer && options.msgContainer.before) {
            options.msgContainer.before(captcha.el)
          } else if (cb) {
            const msgc = cb.find('.msg-container')
            if (msgc.length) {
              msgc.before(captcha.el)
            } else {
              cb.append(captcha.el)
            }
          }
        }

        cb.data('captcha', captcha)
      }
      // IF LOGIN REQUIRED
      if (data.type === CONST.ERROR_LOGINREQUIRED) {
        router.pathRedirect('fos_user_security_login', { msg: data.data, msgType: data.msgType })
      } else if (data.type === CONST.ERROR_MESSAGE) {
        printMsg(data.data, options, 'error')
        callback(options.fail, [data, jqXHR])
        always(data, jqXHR, textStatus, errorThrown, url, options)
        return
      } else if (data.type === CONST.ERROR_FORM) {
        pushFromErrors(data.data, options)
      }
    }
  }

  callback(options.fail, [data, jqXHR, textStatus, errorThrown])
  always(data, jqXHR, textStatus, errorThrown, url, options)
}

function abort(jqXHR, textStatus, errorThrown, url, options) {
  callback(options.abort, [jqXHR])
  always(undefined, jqXHR, textStatus, errorThrown, url, options)
}

function always(data, jqXHR, textStatus, errorThrown, url, options) {
  // console.log('ajax.always()', data, jqXHR, textStatus, errorThrown, url, options);
  callback(options.always, [data, jqXHR])
}

// HELPERS
function get(url, dataType, innerDone, innerFail, msgContainer) {
  if (_.isFunction(dataType) || _.isObject(dataType)) {
    innerDone = dataType
    dataType = 'json'
  }

  if (_.isPlainObject(innerDone)) {
    return ajax(url, {
      type: 'get',
      dataType,
      always: innerDone.always,
      done: innerDone.done,
      fail: innerDone.fail,
      abort: innerDone.abort,
      msgContainer: innerDone.msgContainer,
    })
  }

  return ajax(url, {
    type: 'get',
    dataType,
    done: innerDone,
    fail: innerFail,
    msgContainer,
  })
}

function getJson(url, innerDone, innerFail, msgContainer) {
  get(url, 'json', innerDone, innerFail, msgContainer)
}

function post(url, dataType, data, innerDone, innerFail, msgContainer, form) {
  let obj
  if (_.isPlainObject(innerDone)) {
    obj = {
      type: 'post',
      dataType,
      data,
      always: innerDone.always,
      done: innerDone.done,
      fail: innerDone.fail,
      abort: innerDone.abort,
      msgContainer: innerDone.msgContainer,
      form: innerDone.form,
    }
  } else {
    obj = {
      type: 'post',
      dataType,
      data,
      done: innerDone,
      fail: innerFail,
      msgContainer,
      form,
    }
  }

  if (obj.msgContainer) {
    obj.addMsg = obj.msgContainer
    obj.msgContainer = undefined
  }

  return ajax(url, obj)
}

function callback(cb, params) {
  if (cb && _.isFunction(cb)) {
    cb(...params)
  }
}

function printMsg(msg, o, type) {
  msg = trans(msg)

  if (_.isFunction(o.addMsg)) {
    o.addMsg(msg, type)
    return
  }

  if (o.msgContainer) {
    if (_.isFunction(o.msgContainer)) {
      o.msgContainer(msg, type)
    } else if (o.msgContainer.length) {
      o.msgContainer.infobox(msg, {
        type,
        autoHide: false,
      })
    }
  }
}

function pushFromErrors(errors, o) {
  if (o.form && o.form.length) {
    o.form.pushValidatorErrors(errors, o.addMsg)
  }
}

function ResponseModel(response) {
  if (response === true || response === 1 || response === 'true') {
    response = {
      success: true,
    }
  }
  let model = {
    success: response.success || false,
    type: response.type || CONST.SUCCESS_CONTENT,
    data: response.data || undefined,
    msgType: response.msgType || undefined,
    jqValidatorRules: response.jqValidatorRules || undefined,
  }

  if (response.captcha) {
    model.captcha = response.captcha
  }

  if (response.success === undefined && response.type === undefined) {
    // undefined error
    model = {
      success: false,
      captcha: response.captcha || false,
      type: CONST.ERROR_MESSAGE,
      data: trans('unknown_error'),
    }
  }
  return model
}

module.exports = {
  ajax,
  get,
  getJson,
  post,
}
